import { render, staticRenderFns } from "./StaffProfile.vue?vue&type=template&id=000f03bf&scoped=true&"
import script from "./StaffProfile.vue?vue&type=script&lang=js&"
export * from "./StaffProfile.vue?vue&type=script&lang=js&"
import style0 from "./StaffProfile.vue?vue&type=style&index=0&id=000f03bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000f03bf",
  null
  
)

export default component.exports